$(function () {
  console.log("custom-scripts loaded");

  // Account Buttons
  let jsRecoveryPasswordButton = document.querySelector('.js-recover-password');
  let cancelRecoverPasswordButtons = document.querySelectorAll('.cancel-recover-password');
  let jsCreateAccountButton = document.querySelector('.js-create-account');

  // Forms
  let loginForm = document.querySelector('#login');
  let createForm = document.querySelector('#create-account');
  let recoverForm = document.querySelector('#recover');

  if (jsRecoveryPasswordButton) {
    jsRecoveryPasswordButton.addEventListener('click', () => {
      loginForm.style.display = 'none';
      createForm.style.display = 'none';
      recoverForm.style.display = 'block';
    });
  }

  if (cancelRecoverPasswordButtons.length > 0) {
    cancelRecoverPasswordButtons.forEach(cancelRecoverPasswordButton => {
      cancelRecoverPasswordButton.addEventListener('click', () => {
        loginForm.style.display = 'block';
        createForm.style.display = 'none';
        recoverForm.style.display = 'none';
      });
    });
  }

  if (jsCreateAccountButton) {
    jsCreateAccountButton.addEventListener('click', () => {
      loginForm.style.display = 'none';
      createForm.style.display = 'block';
      recoverForm.style.display = 'none';
    });
  }

  // Keep Slider Working in the Admin
  function inIframe() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }

  if (inIframe()) {
    setInterval(function () {
      if ($(".announcement-slide").length >= 2) {
        $(".announcement-bar-slider").flickity({
          wrapAround: true,
          pageDots: false,
        });
      }
    }, 10);
  }

  if ($(".announcement-slide").length < 2) {
    $(".announcement-bar-slider").flickity("destroy");
  }

  // Collection Banner Description Limit
  /* make sure the word limit is an integer */
  const bannerWordLimit = parseInt(
    $(".collection-content").attr("data-word-limit"),
  );

  function wordLimit(limit, description) {
    let allWordsArray = description.split(" ");
    let contentLength = allWordsArray.length;

    if (contentLength < limit) {
      return $("#collection-description").html(description);
    } else {
      let clippedContent = "";
      if (limit == 1) {
        clippedContent = description.split(" ").splice(0, limit).join(" ");
      } else {
        clippedContent = description
          .split(" ")
          .splice(0, limit - 1)
          .join(" ");
      }
      let clippedReview = '<div class="clipped-review">';
      clippedReview += clippedContent;
      clippedReview += ' <span class="show-more">Read More</span></div>';

      let entireReview = '<div class="entire-review">';
      entireReview += description;
      entireReview += ' <span class="show-less">Show Less</span></div>';

      return $("#collection-description").html(clippedReview + entireReview);
    }
  }

  if (!$("main").hasClass("customer-service-page")) {
    /* Execute banner word limit function */
    if (!$(".banner__content ").hasClass("promo-collection")) {
      if ($("#hidden-description").val()) {
        let parentEle = $("#hidden-description").parent().parent();

        if (parentEle.hasClass("page-content")) {
          $("#page-description").html($("#hidden-description").val());
        } else if (parentEle.hasClass("collection-content")) {
          wordLimit(bannerWordLimit, $("#hidden-description").val());
        }
      }
    }
  }

  $(".show-more").click(function () {
    $(this).parent().parent().addClass("visible");
  });

  $(".show-less").click(function () {
    $(this).parent().parent().removeClass("visible");
  });
  /*
    // Collection Filter
    $('.open-column').click(function (e) {
        e.preventDefault();
        var _this = $(this);
        var target = this.hash;
        var $target = $(target);

        $('.open-side').not(this).removeClass('open-side');

        _this.toggleClass('open-side');
        $target.addClass('open-side');

        if (isScreenSizeLarge()) {
            $target.removeClass('animate__animated');
            $target.removeClass('animate__slideInLeft');
            $target.removeClass('animate__slideOutLeft');
            $target.removeClass('animate__slideInRight');
            $target.removeClass('animate__slideOutRight');

            if (_this.hasClass('open-side')) {
                $('.matrix__wrapper').addClass('smaller-grid');
                $('.container--no-products-in-collection').addClass('smaller-grid');
            } else {
                $('.matrix__wrapper').removeClass('smaller-grid');
                $('.container--no-products-in-collection').removeClass('smaller-grid');
                $target.removeClass('open-side');
            }
        } else {
            if (_this.hasClass('open-side')) {
                $('.matrix__wrapper').addClass('mobile-grid');
                $('.container--no-products-in-collection').addClass('mobile-grid');

                if (target == '#left-column') {
                    $target.addClass('animate__animated');
                    $target.addClass('animate__slideInLeft');
                    $target.removeClass('animate__slideOutLeft');
                } else {
                    $target.addClass('animate__animated');
                    $target.addClass('animate__slideInRight');
                    $target.removeClass('animate__slideOutRight');
                }
            } else {
                $('.matrix__wrapper').removeClass('mobile-grid');
                $('.container--no-products-in-collection').removeClass('mobile-grid');

                if (target == '#left-column') {
                    $target.addClass('animate__slideOutLeft');
                    $target.removeClass('animate__slideInLeft');
                } else {
                    $target.addClass('animate__slideOutRight');
                    $target.removeClass('animate__slideInRight');
                }
            }
        }
    });
*/

  // moving the collection sidebar into
  // a container inside the #left-column
  $(".collection-sidebar").appendTo(".filter-sections");

  // Product Page functions
  // add checked color to element on reload
  $(".selected-color").html($(".colors input:checked").val());

  $(".swatch-element.color").click(function () {
    $(".selected-color").html($(this).data("value"));
  });

  //store location slider
  $(".location-slider").flickity({
    pageDots: false,
  });

  //Customer Service
  $(".single-header").click(function () {
    var _this = $(this);
    var _thisContent = _this.siblings(".single-block-content");
    var otherHeaders = $(".single-header").not(_this);

    otherHeaders.removeClass("active");
    otherHeaders.siblings(".single-block-content").slideUp();

    _this.toggleClass("active");
    _thisContent.slideToggle();
  });

  // Fix mobile menu Golf text
  $('[data-mobile-menu-navlink-handle="golf-mobile"]')
    .children(".mobile-menu__first-level")
    .children(".submenu__label")
    .children("a")
    .text("Golf");
});
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
